import { methods } from "../enums/index.js";
import { apiAction } from "./index.js";

export const fileDataPost = data => ["/file", methods.POST, data];
export const fileDelete = id => [`/file/${id}`, methods.DELETE];
export const fileOneGet = id => apiAction(`/file/one/${id}`);
// eslint-disable-next-line no-undef
export const fileBlobGet = file => `${process.env.REACT_APP_API_UPLOADS_URL}/${file._id.slice(0, 2)}/${file._id}.${file.ext}`;
